import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("anhad_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("anhad_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size = "M", quantity = 1) => {
    setItems((prev) => {
      const key = `${product.id}-${size}`;
      const existing = prev.find((i) => `${i.product_id}-${i.size}` === key);
      if (existing) {
        return prev.map((i) =>
          `${i.product_id}-${i.size}` === key ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          quantity,
          size,
          image: product.images?.[0] || "",
        },
      ];
    });
    toast.success(`${product.name} added to bag`);
  };

  const removeItem = (product_id, size) =>
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.size === size)));

  const updateQty = (product_id, size, quantity) =>
    setItems((prev) =>
      prev.map((i) =>
        i.product_id === product_id && i.size === size ? { ...i, quantity: Math.max(1, quantity) } : i
      )
    );

  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
